var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showReservationPage)?_c('ReservationsPage'):_vm._e(),(_vm.noModulesEnabled)?_c('div',{staticClass:"page-container"},[_c('br'),_c('h1',[_vm._v(" This organisation does not have Workplace and Sensor modules enabled ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }